module.exports = __webpack_public_path__ + "static/media/upload.2a8e47cf.svg";